import { render, staticRenderFns } from "./WeighingDetail.vue?vue&type=template&id=3a04f02e"
import script from "./WeighingDetail.vue?vue&type=script&lang=js"
export * from "./WeighingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports